var React = require('react');

function Bill260px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.981 17.088V56.42c0 1.939-1.556 3.517-3.47 3.517H3.469c-1.914 0-3.47-1.578-3.47-3.517V3.53c0-1.939 1.556-3.517 3.47-3.517h23.519c.045 0 .084.02.128.026a.804.804 0 0 1 .128.025 1 1 0 0 1 .452.243l15.883 15.869c.032.023.047.061.076.087.03.027.052.058.078.089.154.175.267.387.267.639 0 .034-.016.063-.019.097zM27.987 3.423v12.57h12.581L27.987 3.423zM41.981 17.99H26.988c-.553 0-1-.446-1-.999V2.01H3.469c-.811 0-1.471.682-1.471 1.52v52.89c0 .838.66 1.52 1.471 1.52h37.042c.811 0 1.47-.682 1.47-1.52V17.99zm-6.997 28.964h-3.998a.999.999 0 1 1 0-1.998h3.998a.999.999 0 1 1 0 1.998zm0-7.991h-3.998a.998.998 0 1 1 0-1.997h3.998a.999.999 0 1 1 0 1.997zm0-7.99h-3.998a.998.998 0 1 1 0-1.997h3.998a.999.999 0 1 1 0 1.997zm-9.995 15.981H8.995a.999.999 0 1 1 0-1.998h15.994a.999.999 0 1 1 0 1.998zm0-7.991H8.995a.998.998 0 1 1 0-1.997h15.994a.999.999 0 1 1 0 1.997zm0-7.99H8.995a.998.998 0 1 1 0-1.997h15.994a.999.999 0 1 1 0 1.997z","key":1})]);
}

Bill260px.displayName = "Bill260px";

Bill260px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 44 59.94"};

module.exports = Bill260px;

Bill260px.default = Bill260px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/bill-2-60px.svg
// module id = 1182
// module chunks = 0